import React, { useState, useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet';

interface ThemeColorSetterProps {
  color: string;
  colorBg: string;
}

const ThemeColorSetter: React.FC<ThemeColorSetterProps> = ({ color, colorBg }) => {
  const [isHeroVisible, setIsHeroVisible] = useState(true);

  useLayoutEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById("hero-section");
      if (heroSection) {
        const rect = heroSection.getBoundingClientRect();
        setIsHeroVisible(rect.bottom > 0);
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Helmet>
      <meta name="theme-color" content={isHeroVisible ? color : colorBg} />
    </Helmet>
  );
};

export default ThemeColorSetter;
